<template>
  <div class="banner-wrapper" @click="handleBannerClick">
    <swiper
      :slides-per-view="1"
      :loop="true"
      :autoplay="{ delay: 3000, disableOnInteraction: false }"
      :pagination="{ clickable: true }"
      :modules="modules"
      :speed="800"
    >
      <swiper-slide>
        <img src="../assets/image/bannner.png" alt="" />
      </swiper-slide>
      <swiper-slide>
        <img src="../assets/image/banner2.png" alt="" />
      </swiper-slide>
      <swiper-slide>
        <img src="../assets/image/banner3.png" alt="" />
      </swiper-slide>
    </swiper>

    <!-- 文字覆盖层（不干扰点击） -->
    <div class="text-overlay">
      <!-- 左上角：品牌标识 -->
      <div class="brand-badge">中云汇科技集团</div>

      <!-- 主视觉文字组（左下区域，留白舒适） -->
      <div class="hero-text-group">
        <div class="main-title">双碳产业合伙人招募令</div>
        <div class="sub-title">抢占2.3万亿零碳市场入场券</div>
      </div>

      <!-- 左下角标签组 -->
      <div class="feature-badges">
        <span class="badge">党政同责</span>
        <span class="badge">低碳刚需</span>
        <span class="badge">区域独家</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination } from 'swiper/modules'
import { useRouter } from 'vue-router'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

const modules = [Autoplay, Pagination]
const router = useRouter()

const handleBannerClick = () => {
  router.push('/partnerRecruit')   // 请确保路由存在
  // 外部跳转：window.location.href = 'https://...'
}
</script>

<style lang="less" scoped>
.banner-wrapper {
  position: relative;
  width: 100%;
  cursor: pointer;

  // Swiper 基础样式（图片自适应）
  :deep(.swiper) {
    width: 100%;
    height: auto;

    .swiper-slide img {
      width: 100%;
      height: auto;
      display: block;
    }

    // 分页器小圆点样式
    .swiper-pagination-bullet {
      background: rgba(255, 255, 255, 0.7);
      opacity: 1;
    }
    .swiper-pagination-bullet-active {
      background: #ffd966;
    }
  }

  // 绝对定位文字层
  .text-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;   // 点击穿透，确保Banner整体可点
    z-index: 10;
  }

  // ========= 左上品牌徽章 =========
  .brand-badge {
    position: absolute;
    top: 50%;
    left: 5%;
    text-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    // background: rgba(0, 0, 0, 0.55);
    // backdrop-filter: blur(8px);
    padding: 6px 18px;
    border-radius: 40px;
    font-size: 4.5rem;
    font-weight: 800;
    // color: #d0ffc4;
    background: linear-gradient(135deg, #f9f05d, #46ff8c);
    background-clip: text;
    color: transparent;
    letter-spacing: 1px;
    // border: 1px solid rgba(100, 255, 150, 0.6);
    // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    // white-space: nowrap;

    @media (max-width: 768px) {
      padding: 4px 12px;
      font-size: 0.7rem;
      top: 3%;
      left: 4%;
    }
    @media (max-width: 480px) {
      font-size: 0.6rem;
      padding: 3px 10px;
    }
  }

  // ========= 主视觉文字组（左下侧黄金区域） =========
  .hero-text-group {
    position: absolute;
    bottom: 22%;          // 根据不同图片微调，20%~25%比较安全
    left: 3%;
    max-width: 80%;
    text-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);

    @media (max-width: 768px) {
      bottom: 18%;
      left: 3%;
    }
    @media (max-width: 480px) {
      bottom: 15%;
      left: 3%;
    }

    .main-title {
      font-size: clamp(1.8rem, 7vw, 4rem);
      font-weight: 800;
      background: linear-gradient(135deg, #f9f05d, #46ff8c);
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
      line-height: 1.2;
      letter-spacing: 2px;
      margin-bottom: 0.4rem;
      // 兼容不支持渐变的情况
      @supports not (background-clip: text) {
        color: #f2ff80;
        text-shadow: 0 2px 6px #0a3b1e;
      }
    }

    .sub-title {
      font-size: clamp(1rem, 3.5vw, 1.8rem);
      font-weight: 600;
      color: #fff7cf;
      letter-spacing: 5px;
      text-shadow: 0 1px 6px rgba(0, 0, 0, 0.5);
      background: none;
      background-clip: unset;
      -webkit-background-clip: unset;
    }
  }

  // ========= 左下角三个绿色椭圆标签 =========
  .feature-badges {
    position: absolute;
    bottom: 15%;
    left: 9%;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    @media (max-width: 768px) {
      bottom: 4%;
      left: 5%;
      gap: 8px;
    }
    @media (max-width: 480px) {
      bottom: 3%;
      gap: 6px;
    }

    .badge {
      background: rgba(46, 204, 113, 0.88);
      backdrop-filter: blur(4px);
      padding: 6px 20px;
      border-radius: 60px;
      font-size: 0.85rem;
      font-weight: 600;
      color: white;
      letter-spacing: 1px;
      white-space: nowrap;
      border: 1px solid rgba(255, 255, 255, 0.4);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

      @media (max-width: 768px) {
        padding: 4px 14px;
        font-size: 0.7rem;
      }
      @media (max-width: 480px) {
        padding: 3px 10px;
        font-size: 0.6rem;
      }
    }
  }
}
</style>